import { render, staticRenderFns } from "./EditarCalendarioModal.vue?vue&type=template&id=6adf1712&"
import script from "./EditarCalendarioModal.vue?vue&type=script&lang=ts&"
export * from "./EditarCalendarioModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6adf1712', component.options)
    } else {
      api.reload('6adf1712', component.options)
    }
    module.hot.accept("./EditarCalendarioModal.vue?vue&type=template&id=6adf1712&", function () {
      api.rerender('6adf1712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Calendarios/EditarCalendarioModal.vue"
export default component.exports